import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faWhatsapp,
  faInstagram,
  faFacebookF,
  faTiktok,
} from "@fortawesome/free-brands-svg-icons";
import {
  faStore,
  faBell,
  faGift,
  faTags,
} from "@fortawesome/free-solid-svg-icons";
import Seo, { SITE_URL } from "./Seo";
import MissionsSection from "./MissionsSection";

// Juegos deportivos / gigantes — imágenes existentes
import imgJenga from "./assets/jenga.png";
import imgCornhole from "./assets/cornhole.png";
import imgGolfPong from "./assets/golfpong.jpeg";
import imgDomino from "./assets/domino.png";
import imgShuffleboard from "./assets/shuffleboard.png";
import imgBaseball from "./assets/baseball.png";
import imgHockey from "./assets/hockey.png";
import imgRingToss from "./assets/lanzamientodearo.jfif";

// Juegos minis — imágenes existentes
import imgCornholeMini from "./assets/cornhole-mini.png";
import imgCanicas from "./assets/canicas.png";
import imgCatapulta from "./assets/catapulta.png";

// Juegos con precio pero sin foto todavía: Frisbee (en construcción, se deja
// comentado a propósito) y Conecta 4 Gigante.
// GameCard muestra un placeholder ("Foto próximamente") mientras img sea null.
// Cuando llegue la foto: importarla arriba y asignarla al campo `img` del juego.

const GAME_CATEGORIES = [
  {
    id: "deportivos",
    title: "Juegos Deportivos",
    subtitle:
      "Para jardines, eventos al aire libre y reuniones donde el espacio alcanza para todo.",
    theme: "light",
    cardCols: "col-md-6 col-lg-4",
    games: [
      {
        img: imgCornhole,
        name: "Cornhole",
        desc: "Tableros pintados a mano, bolsas incluidas. El juego favorito de todos los que dicen que no saben jugar.",
        priceFrom: "$3,000",
        stats: [
          { label: "Competencia", pct: 70 },
          { label: "Jugadores", pct: 50, text: "2 — 4" },
          { label: "Material", pct: 100, text: "Encino" },
        ],
        waMsg: "Hola, me interesa el Cornhole de Modo Juego",
      },
      // {
      //   img: null,
      //   name: "Frisbee",
      //   desc: "Blancos de madera a distintas alturas y distancias. Lanza el disco y suma puntos, como un disc golf de patio.",
      //   priceFrom: "$6,100",
      //   stats: [
      //     { label: "Puntería", pct: 85 },
      //     { label: "Jugadores", pct: 75, text: "2 — 8" },
      //     { label: "Material", pct: 100, text: "Encino" },
      //   ],
      //   waMsg: "Hola, me interesa el Frisbee de Modo Juego",
      // },
      {
        img: imgGolfPong,
        name: "Golf Pong",
        desc: "Hoyos de madera con obstáculos hechos a mano. Fácil de armar, difícil de dominar.",
        priceFrom: "$7,400",
        stats: [
          { label: "Frustración", pct: 90 },
          { label: "Jugadores", pct: 75, text: "1 — 6" },
          { label: "Material", pct: 100, text: "Encino + pasto sintético" },
        ],
        waMsg: "Hola, me interesa el Golf Pong de Modo Juego",
      },
      {
        img: imgHockey,
        name: "Hockey en Piso",
        desc: "Mesa de hockey hecha en madera. Velocidad, reflejos y mucha discusión sobre los goles.",
        priceFrom: "$7,500",
        stats: [
          { label: "Velocidad", pct: 90 },
          { label: "Jugadores", pct: 25, text: "2" },
          { label: "Material", pct: 100, text: "Encino" },
        ],
        waMsg: "Hola, me interesa el Hockey Piso de Modo Juego",
      },
      {
        img: imgBaseball,
        name: "Baseball",
        desc: "Versión de madera del béisbol clásico. Batea, corre, presume el juego.",
        priceFrom: "$3,500",
        stats: [
          { label: "Energía", pct: 95 },
          { label: "Jugadores", pct: 75, text: "2 — 6" },
          { label: "Material", pct: 100, text: "Pino" },
        ],
        waMsg: "Hola, me interesa el Baseball de Modo Juego",
      },
      {
        img: imgShuffleboard,
        name: "Shuffleboard",
        desc: "Desliza, apunta, gana. La mesa más elegante que vas a tener en tu evento.",
        priceFrom: "$11,500",
        stats: [
          { label: "Precisión", pct: 85 },
          { label: "Jugadores", pct: 50, text: "2 — 4" },
          { label: "Material", pct: 100, text: "Encino" },
        ],
        waMsg: "Hola, me interesa el Shuffleboard de Modo Juego",
      },
    ],
  },
  {
    id: "gigantes",
    title: "Juegos Gigantes",
    subtitle:
      "Los clásicos de mesa, ahora a escala gigante. Mismo juego, todo el jardín como tablero.",
    theme: "dark",
    cardCols: "col-md-6 col-lg-4",
    games: [
      {
        img: imgJenga,
        name: "Jenga",
        desc: "Bloques de encino, tamaño jardín. Cada pieza es una decisión. La torre cae cuando menos lo esperas.",
        priceFrom: "$5,900",
        stats: [
          { label: "Tensión", pct: 80 },
          { label: "Jugadores", pct: 100, text: "2 — ∞" },
          { label: "Material", pct: 100, text: "Encino" },
        ],
        waMsg: "Hola, me interesa el Jenga de Modo Juego",
      },
      {
        img: imgDomino,
        name: "Dominó",
        desc: "Fichas de encino a escala gigante. Un juego de mesa que se convierte en el centro de atención.",
        priceFrom: "$4,000",
        stats: [
          { label: "Estrategia", pct: 75 },
          { label: "Jugadores", pct: 50, text: "2 — 4" },
          { label: "Material", pct: 100, text: "Encino" },
        ],
        waMsg: "Hola, me interesa el Dominó de Modo Juego",
      },
      // {
      //   img: null,
      //   name: "Conecta 4 Gigante",
      //   desc: "El clásico de fichas rojas y amarillas, ahora en versión gigante de madera. Alinea cuatro y gana.",
      //   priceFrom: "$9,500",
      //   stats: [
      //     { label: "Estrategia", pct: 80 },
      //     { label: "Jugadores", pct: 50, text: "2" },
      //     { label: "Material", pct: 100, text: "Encino" },
      //   ],
      //   waMsg: "Hola, me interesa el Conecta 4 Gigante de Modo Juego",
      // },
      // TODO: agregar "Torre en mesa" ($5,000, juego en equipo) cuando esté
      // definida la descripción/ficha — falta info para publicarlo.
    ],
  },
  {
    id: "clasicos",
    title: "Juegos Clásicos",
    subtitle:
      "La próxima colección de Modo Juego: los juegos de toda la vida, hechos a mano.",
    theme: "light",
    cardCols: "col-md-6 col-lg-4",
    games: [
      {
        img: imgRingToss,
        name: "Lanzamiento de Aro",
        desc: "Lanza los aros y encesta en los postes. El juego de feria clásico, hecho en madera y listo para cualquier evento.",
        priceFrom: "$1,600",
        stats: [
          { label: "Puntería", pct: 75 },
          { label: "Jugadores", pct: 100, text: "1 — ∞" },
          { label: "Material", pct: 100, text: "Pino" },
        ],
        waMsg: "Hola, me interesa el Ring Toss de Modo Juego",
      },
    ],
    moreComingText: "Muy pronto sumamos más juegos clásicos a esta colección.",
    emptyText:
      "Estamos preparando nuevos juegos clásicos. Únete a la comunidad para enterarte primero.",
  },
];

const MINI_GAMES = [
  {
    img: imgCornholeMini,
    name: "Cornhole Mini",
    desc: "La versión de mesa del juego estrella. Misma puntería, menos espacio.",
    price: "$250",
    bulkPrice: "$200",
    waMsg: "Hola, me interesa el Cornhole Mini de Modo Juego",
  },
  {
    img: imgCanicas,
    name: "Canicas",
    desc: "Un clásico reinventado con madera y acabado artesanal. Para todas las edades.",
    price: "$250",
    bulkPrice: "$200",
    waMsg: "Hola, me interesa el juego de Canicas de Modo Juego",
  },
  {
    img: imgCatapulta,
    name: "Catapulta",
    desc: "Apunta, jala, lanza. Juego de puntería hecho a mano en encino.",
    price: "$450",
    bulkPrice: "$360",
    waMsg: "Hola, me interesa la Catapulta de Modo Juego",
  },
];

const SOCIAL_LINKS = [
  {
    icon: faInstagram,
    label: "Instagram",
    href: "https://www.instagram.com/colaboratorio.carpintero/",
  },
  {
    icon: faFacebookF,
    label: "Facebook",
    href: "https://www.facebook.com/colaboratorio.carpintero",
  },
  {
    icon: faTiktok,
    label: "TikTok",
    href: "https://www.tiktok.com/@colaboratorio.carpintero",
  },
];

const FAQ_ITEMS = [
  {
    q: "¿Rentan o venden los juegos de Modo Juego?",
    a: "Las dos cosas. Los precios del catálogo son de compra; si buscas renta para un evento, escríbenos por WhatsApp con la fecha y duración para cotizarte.",
  },
  {
    q: "¿Hacen envíos fuera de Guadalajara?",
    a: "Sí. La compra la enviamos a cualquier parte de México. La renta está disponible en Guadalajara y su zona metropolitana.",
  },
  {
    q: "¿Cuánto tardan en entregar un juego?",
    a: "Cada juego se fabrica bajo pedido en nuestro taller de Guadalajara. El tiempo de entrega es de 1 a 2 semanas.",
  },
  {
    q: "¿Cómo puedo pagar?",
    a: "Aceptamos transferencia bancaria, efectivo contra entrega, y tarjeta a través de nuestra tienda en NAS.com.",
  },
  {
    q: "¿Puedo personalizar mi juego?",
    a: "Sí. Ofrecemos grabado láser (nombre, logo o mensaje) y pintura en colores personalizados, incluido en pedidos de compra.",
  },
  {
    q: "¿De qué material están hechos los juegos?",
    a: "Principalmente madera de encino, con acabados resistentes a la intemperie para uso en jardín y exteriores.",
  },
];

function parsePrice(str) {
  return Number(String(str).replace(/[^0-9.]/g, ""));
}

// Un solo Product por juego visible (compra), a partir del mismo catálogo que
// se renderiza — evita mantener precios/nombres duplicados para el JSON-LD.
function buildCatalogJsonLd() {
  const allGames = [
    ...GAME_CATEGORIES.flatMap((cat) => cat.games),
    ...MINI_GAMES,
  ];

  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "Catálogo Modo Juego",
    itemListElement: allGames.map((game, i) => {
      const basePrice = parsePrice(game.priceFrom ?? game.price);
      const description = game.bulkPrice
        ? `${game.desc} Paquete de 10+: ${game.bulkPrice} c/u.`
        : game.desc;
      return {
        "@type": "ListItem",
        position: i + 1,
        item: {
          "@type": "Product",
          name: game.name,
          description,
          image: game.img ? `${window.location.origin}${game.img}` : undefined,
          brand: { "@type": "Brand", name: "Modo Juego" },
          offers: {
            "@type": "Offer",
            price: basePrice.toFixed(2),
            priceCurrency: "MXN",
            availability: "https://schema.org/InStock",
            url: `${SITE_URL}/modo-juego`,
            seller: {
              "@type": "Organization",
              name: "Colaboratorio Carpintero",
            },
          },
        },
      };
    }),
  };
}

function buildFaqJsonLd() {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQ_ITEMS.map(({ q, a }) => ({
      "@type": "Question",
      name: q,
      acceptedAnswer: { "@type": "Answer", text: a },
    })),
  };
}

function StatBar({ label, pct, text }) {
  return (
    <div className="mj-stat mj-stat--light">
      <div className="mj-stat__header">
        <span className="mj-stat__label">{label}</span>
        <span className="mj-stat__value">{text ?? `${pct}%`}</span>
      </div>
      <div className="mj-stat__track">
        <div className="mj-stat__fill" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}

function GameCard({
  img,
  name,
  desc,
  stats,
  priceFrom,
  price,
  bulkPrice,
  waMsg,
}) {
  const badgeText = bulkPrice
    ? `Desde ${bulkPrice} c/u`
    : priceFrom
      ? `Desde ${priceFrom}`
      : null;

  return (
    <div className="mjp-catalog-card">
      {img ? (
        <img src={img} alt={name} className="mjp-catalog-card__img" />
      ) : (
        <div className="mjp-catalog-card__img mjp-catalog-card__img--placeholder">
          <span>Foto próximamente</span>
        </div>
      )}
      {badgeText && (
        <span className="mjp-catalog-card__price">{badgeText}</span>
      )}
      <div className="mjp-catalog-card__body">
        <h3 className="mjp-catalog-card__name">{name}</h3>
        <p className="mjp-catalog-card__desc">{desc}</p>
        {bulkPrice && (
          <p className="mjp-catalog-card__price-note">
            {price} c/u · Paquete 10+: {bulkPrice} c/u
          </p>
        )}
        {stats && (
          <div className="mb-3">
            {stats.map((s) => (
              <StatBar key={s.label} {...s} />
            ))}
          </div>
        )}
        <a
          href={`https://wa.me/5213324922786?text=${encodeURIComponent(waMsg)}`}
          target="_blank"
          rel="noreferrer"
          className="btn btn-outline-primary btn-sm mt-auto"
        >
          <FontAwesomeIcon icon={faWhatsapp} className="me-2" />
          Quiero éste
        </a>
      </div>
    </div>
  );
}

export default function ModoJuego() {
  return (
    <main>
      <Seo
        title="Modo Juego — Juegos gigantes de madera en Guadalajara | Colaboratorio Carpintero"
        description="Cornhole, Jenga gigante, Shuffleboard y más juegos de madera de encino para eventos y jardín. Renta y compra en Guadalajara, envíos a todo México. Precios desde $1,600."
        path="/modo-juego"
        jsonLd={[buildCatalogJsonLd(), buildFaqJsonLd()]}
      />

      {/* HERO */}
      <section className="mjp-hero">
        <div className="container-xl text-center">
          <a href="#unete">
            <span className="mj-badge">▶ CATÁLOGO OFICIAL</span>
          </a>
          <h1 className="mjp-hero__title">MODO JUEGO</h1>
          <p className="mjp-hero__sub">
            Juegos de madera hechos a mano en Guadalajara.
          </p>
          <p className="mjp-hero__sub2">
            Para renta · Para compra · Para cualquier evento o espacio.
          </p>
          <a
            href="https://wa.me/5213324922786?text=Hola,%20me%20interesa%20Modo%20Juego"
            target="_blank"
            rel="noreferrer"
            className="btn btn-primary btn-lg"
          >
            <FontAwesomeIcon icon={faWhatsapp} className="me-2" />
            Hablar por WhatsApp
          </a>

          <div className="mjp-hero__nav">
            <a href="#deportivos" className="mjp-hero__nav-link">
              Deportivos
            </a>
            <span className="mjp-hero__nav-sep">·</span>
            <a href="#gigantes" className="mjp-hero__nav-link">
              Gigantes
            </a>
            <span className="mjp-hero__nav-sep">·</span>
            <a href="#clasicos" className="mjp-hero__nav-link">
              Clásicos
            </a>
            <span className="mjp-hero__nav-sep">·</span>
            <a href="#minis" className="mjp-hero__nav-link">
              Minis
            </a>
            <span className="mjp-hero__nav-sep">·</span>
            <a href="#personalizado" className="mjp-hero__nav-link">
              Personalizado
            </a>
            <span className="mjp-hero__nav-sep">·</span>
            <a href="#misiones" className="mjp-hero__nav-link">
              Misiones
            </a>
          </div>
        </div>
      </section>

      {/* CATEGORÍAS DE JUEGOS (Deportivos / Gigantes / Clásicos) */}
      {GAME_CATEGORIES.map((cat) => (
        <section
          key={cat.id}
          id={cat.id}
          className={`mjp-section mjp-section--${cat.theme}`}
        >
          <div className="container-xl">
            <h2
              className={`section-title${cat.theme === "dark" ? " section-title--light" : ""}`}
            >
              {cat.title}
            </h2>
            <p
              className={`section-subtitle${cat.theme === "dark" ? " mjp-subtitle--dim" : ""}`}
            >
              {cat.subtitle}
            </p>

            {cat.games.length > 0 ? (
              <div className="row g-4">
                {cat.games.map((game) => (
                  <div key={game.name} className={cat.cardCols}>
                    <GameCard {...game} />
                  </div>
                ))}
              </div>
            ) : (
              <div className="mjp-coming-soon">
                <span className="mjp-coming-soon__icon">🛠️</span>
                <h3 className="mjp-coming-soon__title">Muy pronto</h3>
                <p className="mjp-coming-soon__text">{cat.emptyText}</p>
              </div>
            )}

            {cat.games.length > 0 && cat.moreComingText && (
              <p className="mjp-coming-soon-note">{cat.moreComingText}</p>
            )}
          </div>
        </section>
      ))}

      {/* JUEGOS MINIS */}
      <section id="minis" className="mjp-section mjp-section--dark">
        <div className="container-xl">
          <h2 className="section-title section-title--light">Juegos Minis</h2>
          <p className="section-subtitle mjp-subtitle--dim">
            Tamaño mesa. Para espacios más pequeños o para llevar a cualquier
            lado.
          </p>
          <div className="row g-4">
            {MINI_GAMES.map((game) => (
              <div key={game.name} className="col-md-4">
                <GameCard {...game} />
              </div>
            ))}
          </div>

          <div className="mjp-custom-callout mt-5">
            <div className="mjp-custom-callout__content">
              <h3 className="mjp-custom-callout__title">¿Tu idea de juego?</h3>
              <p className="mjp-custom-callout__text">
                Si tienes en mente un juego que no está aquí, cuéntanos. Lo
                diseñamos y fabricamos desde cero.
              </p>
            </div>
            <a
              href="https://wa.me/5213324922786?text=Hola,%20tengo%20una%20idea%20de%20juego%20que%20me%20gustar%C3%ADa%20hacer"
              target="_blank"
              rel="noreferrer"
              className="btn btn-primary btn-lg mjp-custom-callout__btn"
            >
              Cuéntanos tu idea
            </a>
          </div>
        </div>
      </section>

      {/* PERSONALIZACIÓN */}
      <section id="personalizado" className="mjp-section mjp-section--light">
        <div className="container-xl">
          <h2 className="section-title">Lo hacemos tuyo</h2>
          <p className="section-subtitle">
            Cada pieza puede llevar tu sello. Colores, logotipo o el diseño que
            imaginas.
          </p>
          <div className="row g-4 mb-5">
            <div className="col-md-6">
              <div className="mjp-feature-card">
                <span className="mjp-feature-card__icon">✏️</span>
                <h3 className="mjp-feature-card__title">Grabado láser</h3>
                <p className="mjp-feature-card__text">
                  Tu nombre, logo, fecha o mensaje. El grabado queda en la
                  madera para siempre. Incluido en cualquier pieza en pedidos de
                  compra.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="mjp-feature-card">
                <span className="mjp-feature-card__icon">🎨</span>
                <h3 className="mjp-feature-card__title">
                  Colores personalizados
                </h3>
                <p className="mjp-feature-card__text">
                  Pintamos los juegos con los colores de tu empresa o evento.
                  Acabados resistentes a la intemperie.
                </p>
              </div>
            </div>
          </div>

          <div className="mjp-custom-callout mjp-custom-callout--light">
            <div className="mjp-custom-callout__content">
              <h3 className="mjp-custom-callout__title">
                ¿Tienes algo específico en mente?
              </h3>
              <p className="mjp-custom-callout__text">
                Mándanos una foto de referencia, un boceto o simplemente
                explícanos la idea. Lo hacemos realidad.
              </p>
            </div>
            <a
              href="https://wa.me/5213324922786?text=Hola,%20quiero%20personalizar%20un%20juego%20de%20Modo%20Juego"
              target="_blank"
              rel="noreferrer"
              className="btn btn-primary btn-lg mjp-custom-callout__btn"
            >
              Personalizar mi juego
            </a>
          </div>
        </div>
      </section>

      {/* MISIONES 2026 — mapa de progreso de la comunidad */}
      <MissionsSection />

      {/* ÚNETE A MODO JUEGO — comunidad NAS */}
      <section id="unete" className="mjp-section mjp-section--dark">
        <div className="container-xl">
          <h2 className="section-title section-title--light text-center">
            Únete a Modo Juego
          </h2>
          <p className="section-subtitle text-center mjp-subtitle--dim">
            Regístrate gratis en nuestra comunidad y desbloquea estos
            beneficios.
          </p>

          <div className="row g-4 align-items-center mt-2">
            <div className="col-lg-5">
              <div className="mjp-benefit-list">
                <div className="mjp-benefit">
                  <FontAwesomeIcon
                    icon={faBell}
                    className="mjp-benefit__icon"
                  />
                  <div>
                    <h3 className="mjp-benefit__title">Entérate primero</h3>
                    <p className="mjp-benefit__text">
                      Avisamos a la comunidad antes que a nadie cuando lanzamos
                      un juego nuevo.
                    </p>
                  </div>
                </div>
                <div className="mjp-benefit">
                  <FontAwesomeIcon
                    icon={faTags}
                    className="mjp-benefit__icon"
                  />
                  <div>
                    <h3 className="mjp-benefit__title">
                      Descuentos en juegos individuales
                    </h3>
                    <p className="mjp-benefit__text">
                      Los miembros de la comunidad reciben descuentos exclusivos
                      al comprar juegos por separado.
                    </p>
                  </div>
                </div>
                <div className="mjp-benefit">
                  <FontAwesomeIcon
                    icon={faGift}
                    className="mjp-benefit__icon"
                  />
                  <div>
                    <h3 className="mjp-benefit__title">
                      Paquete para emprendedor
                    </h3>
                    <p className="mjp-benefit__text">
                      Al registrarte recibes automáticamente nuestro catálogo
                      digital, con fichas y precios de mayoreo.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-7">
              <div className="mjp-iframe-wrap">
                <iframe
                  title="GERARDOS_BUSINESS_821009 checkout widget"
                  src="https://nas.com/checkout-widget?communityCode=GERARDOS_BUSINESS_821009&communitySlug=%2Fmodo-juego&buttonText=Unirme%20como%20miembro&buttonTextColorHex=%23121212&buttonBgColorHex=%23fccb1d&widgetTheme=light&backgroundColorHex=%23fff"
                  width="100%"
                  height="320"
                  frameBorder="0"
                  referrerPolicy="no-referrer"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PREGUNTAS FRECUENTES */}
      <section id="faq" className="mjp-section mjp-section--light">
        <div className="container-xl">
          <h2 className="section-title text-center">Preguntas frecuentes</h2>
          <p className="section-subtitle text-center">
            Lo que más nos preguntan antes de rentar o comprar.
          </p>
          <div className="mjp-faq-list">
            {FAQ_ITEMS.map(({ q, a }) => (
              <details key={q} className="mjp-faq-item">
                <summary className="mjp-faq-item__question">{q}</summary>
                <p className="mjp-faq-item__answer">{a}</p>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* CANALES DE COMPRA */}
      <section className="mjp-section mjp-section--green">
        <div className="container-xl">
          <h2 className="section-title section-title--light text-center">
            ¿Cómo compramos?
          </h2>
          <p className="section-subtitle text-center mjp-subtitle--dim">
            Elige el canal que prefieras. Respondemos rápido.
          </p>

          <div className="row g-4 justify-content-center mt-2">
            {/* WhatsApp */}
            <div className="col-md-4">
              <div className="mjp-contact-card">
                <FontAwesomeIcon
                  icon={faWhatsapp}
                  className="mjp-contact-card__icon"
                />
                <h3 className="mjp-contact-card__label">WhatsApp</h3>
                <p className="mjp-contact-card__handle">332 492 2786</p>
                <a
                  href="https://wa.me/5213324922786?text=Hola,%20me%20interesa%20Modo%20Juego"
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-outline-light btn-sm"
                >
                  Escribir ahora
                </a>
              </div>
            </div>

            {/* Redes Sociales */}
            <div className="col-md-4">
              <div className="mjp-contact-card">
                <div className="mjp-contact-card__social-icons">
                  {SOCIAL_LINKS.map(({ icon, label, href }) => (
                    <a
                      key={label}
                      href={href}
                      target="_blank"
                      rel="noreferrer"
                      aria-label={label}
                      className="mjp-contact-card__social-link"
                    >
                      <FontAwesomeIcon icon={icon} />
                    </a>
                  ))}
                </div>
                <h3 className="mjp-contact-card__label">Redes Sociales</h3>
                <p className="mjp-contact-card__handle">
                  @colaboratorio.carpintero
                </p>
                <a
                  href="https://www.instagram.com/colaboratorio.carpintero/"
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-outline-light btn-sm"
                >
                  Enviar DM
                </a>
              </div>
            </div>

            {/* NAS.com */}
            <div className="col-md-4">
              <div className="mjp-contact-card">
                <FontAwesomeIcon
                  icon={faStore}
                  className="mjp-contact-card__icon"
                />
                <h3 className="mjp-contact-card__label">NAS.com</h3>
                <p className="mjp-contact-card__handle">Modo Juego</p>
                <a
                  href="https://nas.com/es-mx/modo-juego"
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-outline-light btn-sm"
                >
                  Ver en tienda
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
